/** 高性能队列 由ChatGpt3.5生成 */
class RollingQueue {
  constructor(capacity = 100) {
    this.capacity = 100;
    this.head = 0;
    this.tail = 0;
    this.buffer = new Array(0);
    this.capacity = capacity;
    this.buffer = new Array(capacity);
  }
  push(value) {
    if (this.size() === this.capacity - 1) {
      this.resize();
    }
    this.buffer[this.tail] = value;
    this.tail = (this.tail + 1) % this.capacity;
  }
  pop() {
    if (this.isEmpty()) {
      throw new Error('Queue is empty');
    }
    const value = this.buffer[this.head];
    this.buffer[this.head] = null;
    this.head = (this.head + 1) % this.capacity;
    return value;
  }
  size() {
    return (this.tail - this.head + this.capacity) % this.capacity;
  }
  isEmpty() {
    return this.head === this.tail;
  }
  resize() {
    const newCapacity = this.capacity * 2;
    const newBuffer = new Array(newCapacity);
    let i = 0;
    let j = this.head;
    while (j !== this.tail) {
      newBuffer[i] = this.buffer[j];
      i += 1;
      j = (j + 1) % this.capacity;
    }
    this.buffer = newBuffer;
    this.capacity = newCapacity;
    this.head = 0;
    this.tail = i;
  }
}
/** 在dom上进行bfs 提供一个回调 返回true来提前结束子树的bfs */
export function* domBfs(root, jumpBfsCb) {
  // 创建一个队列并将根节点入队
  const queue = new RollingQueue();
  queue.push(root);
  // 循环遍历队列中的所有节点
  while (!queue.isEmpty()) {
    // 取出队列中的第一个节点
    const node = queue.pop();
    // 处理当前节点
    const jump = jumpBfsCb(node);
    if (jump) {
      continue;
    }
    yield node;
    // 将当前节点的子节点依次入队
    const {
      children
    } = node;
    for (let i = 0; i < children.length; i++) {
      queue.push(children[i]);
    }
  }
}
/** 在dom上进行dfs 提供一个回调 返回true来提前结束子树的bfs 由chatgpt3.5生成 */
export function* domDfs(root, jumpDfsCb, returnLeaf = false) {
  const stack = [root]; // 初始化栈，将根节点入栈
  while (stack.length > 0) {
    const node = stack.pop(); // 取出栈顶节点
    const {
      children
    } = node; // 获取该节点的子节点
    let pushed = 0;
    for (let i = children.length - 1; i >= 0; i--) {
      const node = children[i];
      if (jumpDfsCb(node)) {
        continue;
      }
      stack.push(node); // 将子节点入栈，注意要倒序入栈，保证先访问左子树
      pushed += 1;
    }
    const isLeaf = !pushed;
    if (!(returnLeaf && !isLeaf)) {
      yield node;
    }
  }
}
//# sourceMappingURL=domBfs.js.map
